import type {
    BookableSessionId} from "@@/shared/acquire/sessions/bookable-session-id";
import {
    bookableSessionIdZodSchema,
} from "@@/shared/acquire/sessions/bookable-session-id";

import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { productIdZodSchema } from "../product-id";
import type { ProductCommandCommon } from "./product-commands-common";

type BookableMoveSessionsToNewSeries = ProductCommandCommon & {
    readonly _id: string;
    readonly _type: "BOOKABLE_MOVE_SESSIONS_TO_NEW_SERIES";
    readonly sessionIds: BookableSessionId[];
};

type FactoryParams = Except<
    ProductCommandCommon & BookableMoveSessionsToNewSeries,
    "_id" | "_type" | "_createdAt"
>;
const bookableMoveSessionsToNewSeriesFactory = (params: FactoryParams) => {
    const editCommand: BookableMoveSessionsToNewSeries = {
        ...params,
        _id: generateId({ prefix: "BOOKABLE_MOVE_SESSIONS_TO_NEW_SERIES__" }),
        _type: "BOOKABLE_MOVE_SESSIONS_TO_NEW_SERIES",
        _createdAt: nowIsoAndUnix(),
    };
    return editCommand;
};

const bookableMoveSessionsToNewSeriesZodSchema: z.ZodSchema<BookableMoveSessionsToNewSeries> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("BOOKABLE_MOVE_SESSIONS_TO_NEW_SERIES"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        productId: productIdZodSchema,
        sessionIds: z.array(bookableSessionIdZodSchema),
    });

export {
    bookableMoveSessionsToNewSeriesFactory,
    bookableMoveSessionsToNewSeriesZodSchema,
};
export type {
    BookableMoveSessionsToNewSeries,
    FactoryParams as CreateBookableMoveSessionsToNewSeriesParams,
};
